import { Subdomain } from '@/domain/value-object/Subdomain'
import { PlanLimitService } from '@/domain/service/PlanLimitService'
import { SiteCreated } from '@/domain/events/SiteEvents'
import type { ICreateSitePort, CreateSiteCommand } from '@/application/port/in/ICreateSitePort'
import type { ITenantRepository } from '@/application/port/out/ITenantRepository'
import type { ISiteRepository } from '@/application/port/out/ISiteRepository'
import type { IDomainEventBus } from '@/application/port/out/IDomainEventBus'
import type { Site } from '@/domain/model/Site'

const planLimits = new PlanLimitService()

export class CreateSiteService implements ICreateSitePort {
  constructor(
    private readonly tenantRepository: ITenantRepository,
    private readonly siteRepository: ISiteRepository,
    private readonly eventBus: IDomainEventBus,
  ) {}

  async execute(command: CreateSiteCommand): Promise<Site> {
    const tenant = await this.tenantRepository.findById(command.tenantId)
    if (!tenant) throw new Error('Tenant not found')

    const siteCount = await this.siteRepository.countByTenantId(command.tenantId)
    planLimits.assertCanCreateSite(tenant, siteCount)

    const subdomain = Subdomain.from(command.subdomain)
    const taken = await this.siteRepository.findBySubdomain(subdomain.toString())
    if (taken) throw new Error(`Subdomain "${subdomain}" is already taken`)

    const site = await this.siteRepository.create({
      tenantId:  command.tenantId,
      name:      command.name.trim(),
      subdomain: subdomain.toString(),
    })

    await this.eventBus.dispatch([
      new SiteCreated(site.id, site.tenantId, site.subdomain, site.name),
    ])

    return site
  }
}
